import "./about.css";

import React, { useState } from "react";
import { Surface } from "gl-react-dom";
import { Card, Typography, Steps } from "antd";

import { Normalize } from "./Normalize";

const { Title, Paragraph } = Typography;
const { Step } = Steps;

const Tutorial = ({ index }) => {
  const width = 200,
    height = 200;

  if (index === 0) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}
      >
        <img width={width} height={height} src="8P.png" alt="daltonism" />
      </div>
    );
  }

  return (
    <div
      style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}
    >
      <Surface width={200} height={200}>
        <Normalize intensity={1} daltonism={2} step={index}>
          /8P.png
        </Normalize>
      </Surface>
    </div>
  );
};

const explanations = [
  null,
  "A imagem original é modificada para simular a visão do daltonismo",
  "É feita a diferença entre a original e a simulação para encontrar quais cores são afetadas",
  "As cores afetadas são desviadas para o espectro de cor que o daltonico não tem problemas em enxergar"
];

export const AboutScreen = () => {
  const [current, setCurrent] = useState(0);
  console.log({ current });
  return (
    <div className="about">
      <Card>
        <Title level={3}>Como funciona o aplicativo?</Title>
        <Paragraph type="secondary">
          Entenda como as imagens são manipuladas para auxiliar na diferenciação
          das cores
        </Paragraph>
        <div className="spacer"></div>
        <Steps current={current} onChange={setCurrent}>
          <Step title="Original"></Step>
          <Step title="Simulação"></Step>
          <Step title="Delta"></Step>
          <Step title="Correção"></Step>
        </Steps>
        <div className="spacer"></div>
        <Card className="slide" cover={<Tutorial index={current}></Tutorial>}>
          <Paragraph style={{ textAlign: "center" }}>
            {explanations[current]}
          </Paragraph>
        </Card>
      </Card>
    </div>
  );
};
